import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { TECEO_NEWS_URL } from '../../../../utils/constants';
import { useTranslation } from '../../../translation/TranslationContext';
import RachelSparkIcon from '../RachelSparkIcon/RachelSparkIcon';
import {
  RachelEmptyConversationSize,
  SPARK_ACCENT_STROKE_OPACITY,
  SPARK_MUTED_STROKE_OPACITY,
  SPARK_STROKE_WIDTH,
  getRachelEmptyConversationSparkSize,
  useRachelEmptyConversationStyles,
} from './rachelEmptyConversation.styles';

interface RachelEmptyConversationViewProps {
  userName?: string;
  isFocused: boolean;
  size?: RachelEmptyConversationSize;
}

const RachelEmptyConversationView = ({
  userName,
  isFocused,
  size = 'compact',
}: RachelEmptyConversationViewProps) => {
  const { translate } = useTranslation();
  const { classes, cx } = useRachelEmptyConversationStyles({ isFocused, size });
  const sparkSize = getRachelEmptyConversationSparkSize(size);

  return (
    <Box className={classes.root}>
      <Box className={classes.greetingBlock}>
        <Box className={classes.sparkSlot}>
          <Box className={classes.sparkFrame}>
            <Box className={cx(classes.sparkLayer, classes.sparkAccent)}>
              <RachelSparkIcon
                size={sparkSize}
                strokeWidth={SPARK_STROKE_WIDTH}
                strokeOpacity={SPARK_ACCENT_STROKE_OPACITY}
              />
            </Box>
            <Box className={cx(classes.sparkLayer, classes.sparkMuted)}>
              <RachelSparkIcon
                size={sparkSize}
                color="currentColor"
                strokeWidth={SPARK_STROKE_WIDTH}
                strokeOpacity={SPARK_MUTED_STROKE_OPACITY}
              />
            </Box>
          </Box>
        </Box>
        <Box className={classes.messages}>
          {!!userName && (
            <Typography variant="subtitle1" color="text.primary" className={classes.line}>
              {translate(LangEnum.RACHEL_EMPTY_GREETING, { user: userName })}
            </Typography>
          )}
          <Box className={classes.headlineSlot}>
            <Typography
              variant="subtitle1"
              aria-hidden={!isFocused}
              className={cx(classes.line, classes.headline, classes.headlineAccent)}
            >
              {translate(LangEnum.RACHEL_EMPTY_QUESTION)}
            </Typography>
            <Typography
              variant="subtitle1"
              aria-hidden={isFocused}
              className={cx(classes.line, classes.headline, classes.headlineMuted)}
            >
              {translate(LangEnum.RACHEL_EMPTY_READY)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        component="a"
        href={TECEO_NEWS_URL}
        target="_blank"
        rel="noopener noreferrer"
        test-id="rachel-empty-conversation-news"
        className={classes.news}
      >
        <Box className={classes.newsDot} />
        <Typography variant="body2" color="text.secondary">
          {translate(LangEnum.GLOBAL_NEWS)}
        </Typography>
      </Box>
    </Box>
  );
};

export default RachelEmptyConversationView;
